<template>
  <div>
    <ValidationObserver ref="observer" v-slot="{ invalid, dirty }">
      <v-container fluid class="pb-0" grid-list-xl>
        <v-layout wrap>
          <v-flex lg6>
            <v-combobox
              v-model="selected"
              label="* Select lookup type"
              :items="
                services === 'Business Fibre'
                  ? ['Physical Address']
                  : services !== '5G'
                  ? items
                  : items.filter((x) => x !== 'Location ID' && x !== 'Geocode')
              "
              :disabled="withData"
              @change="resetValidation($event)"
            ></v-combobox>
            <v-btn large color="primary" @click="showAddressMissing">
              Can't find address
            </v-btn>

            <v-layout v-if="selected !== 'Location ID'" wrap>
              <v-flex lg12 sm12 md12>
                <v-layout v-if="selected === 'Physical Address'" wrap>
                  <v-flex sm12 md12 lg12>
                    <!-- item-value="formatted_address" -->
                    <vonex-autocomplete
                      v-model="streetAddress"
                      :items="results"
                      label="Search for physical street address, not PO Box"
                      :search-input.sync="search"
                      item-text="formatted_address"
                      :filter="customFilter"
                      persistent-hint
                      name="address_search"
                      :rule="'required'"
                      hide-details
                      return-object
                      :options="fieldConditions"
                      :browser-autocomplete="
                        isGoogleChrome ? 'disabled' : 'off'
                      "
                      @change="completeAddress"
                    ></vonex-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout v-if="selected === 'Geocode'" wrap>
                  <v-flex sm6 md6 lg6>
                    <vonex-text
                      v-model="latitude"
                      label="Latitude"
                      hide-details
                      rule="required|between:-180.999999,180.999999"
                      outline
                      :options="fieldConditions"
                    ></vonex-text>
                  </v-flex>
                  <v-flex sm6 md6 lg6>
                    <vonex-text
                      v-model="longitude"
                      label="Longitude"
                      hide-details
                      rule="required|between:-180.999999,180.999999"
                      outline
                      :options="fieldConditions"
                    ></vonex-text>
                  </v-flex>
                </v-layout>
                <v-layout v-if="selected === 'GNAF ID'" wrap>
                  <v-flex sm12 md12 lg12>
                    <vonex-text
                      v-model="gnafId"
                      label="GNAF ID"
                      hide-details
                      :rule="'required'"
                      outline
                      :options="fieldConditions"
                      :disabled="disableSearch"
                    ></vonex-text>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex
                v-if="selected === 'GNAF ID' || selected == 'Geocode'"
                class="py-0"
                xs12
              >
                <v-btn
                  large
                  color="primary"
                  :disabled="!isDisabled"
                  @click="checkValues"
                >
                  Search
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex lg6>
            <v-layout wrap>
              <v-radio-group v-model="services" column>
                <v-radio color="#2f5578" value="nbn">
                  <template #label>
                    <div>
                      <strong>Business ’Standard’ NBN</strong>
                      <div class="font-weight-regular text-caption caption">
                        Conduct a ‘live’ service qualification based on Vonex’s
                        standard NBN services
                      </div>
                    </div>
                  </template>
                </v-radio>
                <v-radio color="#2f5578" value="5G">
                  <template #label>
                    <div>
                      <strong>Business 5G</strong>
                      <div class="font-weight-regular text-caption caption">
                        Conduct a service qualification for Optus’ 5G services
                      </div>
                    </div>
                  </template>
                </v-radio>
                <v-radio color="#2f5578" value="Business Fibre">
                  <template #label>
                    <div>
                      <strong>Business Fibre (NBN Enterprise Ethernet, AAPT and Telstra
                      Ethernet Access)</strong>
                      <div class="font-weight-regular text-caption caption">
                        Qualify to our faster & better grade of service products
                      </div>
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </ValidationObserver>
    <utility-finder-invalid-address
      :show-dialog="showDialog"
      :invalid-items="invalidItems"
      :is-invalid="isInvalid"
      :title="title"
      :is-validated="isValidated"
      @toggleLoading="(val) => $emit('toggleLoading', val)"
      @close="showDialog = false"
    />
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapAddressActions, mapMutations: mapAddressMutations } =
  createNamespacedHelpers(`orders/address`);
const { mapActions: mapSQActions } = createNamespacedHelpers(`orders/sq`);
const { mapActions: mapSQAddressActions } =
  createNamespacedHelpers(`orders/sqAddress`);
const { mapMutations: mapSQMutations } =
  createNamespacedHelpers(`orders/sqAddress`);
const { mapGetters: mapSQAddressGetters } =
  createNamespacedHelpers(`orders/sqAddress`);
import Utils from '@/mixins/utils.mixin';
import UtilityFinderInvalidAddress from '../utility-finder-invalid-address';
import { Address } from '../../../models/Address';

export default {
  name: 'UtilityServiceQualificationForm',
  components: {
    UtilityFinderInvalidAddress,
  },
  mixins: [Utils],
  props: {
    addressList: Array,
    send: Boolean,
  },
  data() {
    return {
      isDataLoading: false,
      isSaved: false,
      isSubmittedSuccessfully: false,
      isLoaded: false,
      search: null,
      streetAddress: null,
      suburb: null,
      state: null,
      postCode: null,
      results: [],
      address: null,
      services: 'nbn',
      items: ['Physical Address', 'Location ID', 'Geocode', 'GNAF ID'],
      selected: 'Physical Address',
      withData: false,
      disableRadio: false,
      longitude: '',
      latitude: '',
      gnafId: '',
      result: {
        suburb: '',
        state: '',
        postCode: '',
        streetAddress: '',
        gnafId: '',
      },
      queryAddress: [],
      title: '',
      showDialog: false,
      isValidated: false,
      isInvalid: false,
      invalidItems: [],
    };
  },
  methods: {
    ...mapSQMutations(['SET_FULL_ADDRESS']),
    ...mapAddressActions(['searchAddress', 'createAddress']),
    ...mapSQActions([
      'reset5gSq',
      'resetHasSectorId',
      'addressQuery',
      'serviceQualification5G',
      'setOrderType',
      'setLocationID',
      'resetFormattedSQResult',
    ]),
    ...mapSQAddressActions(['getFullAddress']),
    clearDropdown: function (e) {
      let vm = this;
      vm.results = [];
    },
    addAddressToList() {
      let vm = this;
      if (vm.fullAddress) {
        vm.addressList.push(vm.fullAddress);
        vm.$emit('close');
      }
    },
    sendAddress() {
      let vm = this;
      vm.fullAddress.services = [vm.services];
      if (vm.fullAddress) vm.$emit('sendAddress', vm.fullAddress);
    },

    submit() {
      let vm = this;
      let payload = {};
      let data = {};
      let methodType = '';
      if (vm.services === 'Business Fibre') {
        vm.$emit('toggleLoading', false);
        vm.sendAddress();
        return;
      }
      switch (vm.selected) {
        case 'Location ID':
          methodType = 'NBN_LOCATION_ID';
          data = { LocationId: vm.locationId };
          break;
        case 'Physical Address':
          methodType = 'PHYSICAL_ADDRESS';

          if (vm.services === 'nbn') {
            data = {
              StateOrProvince: vm.fullAddress.state,
              Postcode: vm.fullAddress.postcode,
              Suburb: vm.fullAddress.suburb,
              StreetName: vm.fullAddress.street_name,
              StreetType: vm.fullAddress.street_type,
              StreetNrFirst: vm.fullAddress.street_number,
            };
          } else {
            data = {
              streetAddress: vm.fullAddress.street_address,
              unitNumber: '',
              unitType: '',
              streetNumber: vm.fullAddress.street_number,
              streetName: vm.fullAddress.street_name,
              streetType: vm.fullAddress.street_type,
              streetSuffix: vm.fullAddress.street_suffix,
              suburb: vm.fullAddress.suburb,
              postCode: vm.fullAddress.postcode,
              state: vm.fullAddress.state,
              gNAFIdentifier: vm.fullAddress.gnaf_id,
            };
          }
          break;
        case 'Geocode':
          methodType = 'GEOCODE';
          data = {
            Longtitude: vm.longitude,
            Latitude: vm.latitude,
          };
          break;
        case 'GNAF ID':
          methodType = 'GNAF_ID';

          if (vm.services === 'nbn') data = { Gnafld: vm.gnafId };
          else {
            data = {
              streetAddress: vm.fullAddress.street_address,
              unitNumber: '',
              unitType: '',
              streetNumber: vm.fullAddress.street_number,
              streetName: vm.fullAddress.street_name,
              streetType: vm.fullAddress.street_type,
              streetSuffix: vm.fullAddress.street_suffix,
              suburb: vm.fullAddress.suburb,
              postCode: vm.fullAddress.postcode,
              state: vm.fullAddress.state,
              gNAFIdentifier: vm.fullAddress.gnaf_id,
            };
          }
          break;
      }
      if (vm.services === 'nbn') {
        payload = {
          addressCheckServiceType: 'NBN',
          addressCheckMethodType: methodType,
          Address: data,
        };

        vm.addressQuery(payload)
          .then((data) => {
            if (data) {
              vm.setResult(data);
              let details = {
                queryAddress: vm.queryAddress,
                streetAddress: vm.streetAddress,
                populatedAddress: vm.result,
                result: data,
              };
              vm.$emit('showResultSection', details);
            }
          })
          .catch((err) => {
            vm.$emit('toggleLoading', false);
          })
          .finally(() => {
            if (vm.selected != 'GNAF ID') vm.$emit('toggleLoading', false);
          });
      } else {
        vm.serviceQualification5G(data)
          .then(() => {
            vm.$emit('showResultSection', {});
          })
          .catch((err) => {
            vm.$emit('toggleLoading', false);
          })
          .finally(() => {
            vm.$emit('toggleLoading', false);
          });
      }
    },

    completeAddress(address) {
      let vm = this;
      vm.reset5gSq();
      vm.resetHasSectorId();
      vm.invalidItems = [];
      vm.$emit('toggleLoading', true);
      vm.getFullAddress(address.search_result_id).then((addressResults) => {
        if (addressResults.gnafId === '') {
          if (addressResults.state === '') vm.invalidItems.push('state');
          else if (addressResults.postcode === '')
            vm.invalidItems.push('postcode');
          else if (addressResults.suburb === '')
            vm.invalidItems.push('postcode');
          else if (addressResults.street_name === '')
            vm.invalidItems.push('street name');
          else if (addressResults.street_type === '')
            vm.invalidItems.push('street type');
          else if (addressResults.street_number === '')
            vm.invalidItems.push('street number');
          vm.isValidated = true;
          vm.isInvalid = true;
          vm.showAddressDialog('Error Details');
          vm.$emit('toggleDisabled', true);
        } else {
          vm.suburb = addressResults.suburb;
          vm.state = addressResults.state;
          vm.postCode = addressResults.postcode;
          vm.streetAddress = addressResults.formatted_address;
          vm.submit();
        }
      });
      // }
    },
    customFilter(item, queryText, itemText) {
      // return true
      var words = queryText.split(' ').filter((x) => x.length > 0);
      var result = false;
      words.forEach((x) => {
        result = result || itemText.toLowerCase().includes(x.toLowerCase());
      });
      return result;
    },

    resetValidation(event) {
      let vm = this;
      //TO DO: change path to /service-qualification (feature flag)
      if (vm.$route.path === '/service-qualification-5g') {
        if (event === 'Location ID' || event === 'Geocode') {
          vm.services = 'nbn';
          vm.disableRadio = true;
        } else {
          vm.disableRadio = false;
        }
      }

      vm.latitude = '';
      vm.longitude = '';
      vm.streetAddress = '';
      vm.gnafId = '';
      vm.selected = event;
      vm.result = {
        suburb: '',
        state: '',
        postCode: '',
        streetAddress: '',
      };
      vm.setLocationID('');
      vm.resetFormattedSQResult();
      vm.id = '';
      vm.queryAddress = [];
      vm.reset5gSq();
      vm.$emit('changed', event);
      vm.$refs.observer.reset();
    },
    showAddressDialog(title) {
      let vm = this;
      vm.title = title;
      vm.showDialog = true;
    },
    showAddressMissing() {
      let vm = this;
      vm.showAddressDialog('Address Not Found');
    },
    setResult(result) {
      let vm = this;
      vm.queryAddress = vm.reformatResult(result.addresses);
    },
    reformatResult(result) {
      let vm = this;
      let newAddress = [];
      result.forEach((x) => {
        let addressFormat = {
          streetNrFirst: vm.setValue(x, 'streetNrFirst'),
          streetNrLast: vm.setValue(x, 'streetNrLast'),
          streetName: vm.setValue(x, 'streetName'),
          streetType: vm.setValue(x, 'streetType'),
          suburb: vm.setValue(x, 'suburb'),
          postcode: vm.setValue(x, 'postcode'),
          stateOrProvince: vm.setValue(x, 'stateOrProvince'),
          longitude: vm.setValue(x, 'longitude'),
          latitude: vm.setValue(x, 'latitude'),
          locationId: vm.setValue(x, 'locationId'),
          formattedAddress: vm.setValue(x, 'formattedAddress'),
          lotNumber: vm.setValue(x, 'lotNumber')
            ? vm.setValue(x, 'lotNumber')
            : '',
        };

        newAddress.push(addressFormat);
      });

      return newAddress;
    },
    setValue(address, name) {
      let value = '';
      address.forEach((x) => {
        if (x.name === name) value = x.value;
      });

      return value;
    },
    changeServiceType(val) {
      let vm = this;
      vm.setOrderType(val);
      vm.resetValidation('Physical Address');
    },
    checkValues() {
      let vm = this;
      if (!this.isDisabled) vm.$emit('toggleDisabled', true);
      else {
        vm.$emit('toggleDisabled', false);
        vm.$emit('toggleLoading', true);
        vm.submit();
      }
    },
  },
  computed: {
    isDisabled() {
      switch (this.selected) {
        case 'Geocode':
          return this.latitude != '' && this.longitude != '';
        case 'GNAF ID':
          return this.gnafId != '';
      }

      return false;
    },
    isGoogleChrome() {
      return (
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor)
      );
    },
    showSubmit() {
      let vm = this;
      return vm.services === 'Business Fibre';
    },
    disableSearch() {
      let vm = this;
      if (vm.$route.path === '/') {
        return false;
      } else {
        return vm.withData || vm.services === '';
      }
    },
    ...mapSQAddressGetters(['fullAddress']),
  },
  watch: {
    search(val) {
      if (val !== null) {
        if (val.length > 5)
          this.searchAddress(val).then((res) => (this.results = res));
      }
    },
    services(val) {
      let vm = this;
      vm.changeServiceType(val);
      vm.$refs.observer.reset();
      return val;
    },
    checkType() {
      let vm = this;
      vm.clear();
    },

    selected() {
      let vm = this;
      vm.streetAddress = '';
      if (vm.selected === 'Location ID') vm.$emit('toggleInput', true);
      else vm.$emit('toggleInput', false);
    },
  },
  mounted() {
    let vm = this;
    vm.reset5gSq();
    vm.changeServiceType('nbn');
  },
};
</script>
